import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
/**
 * Loading skeleton row for tables
 */
export const LoadingRow = () => (_jsx("tr", { class: "animate-pulse", children: _jsx("td", { class: "py-3 px-4", colSpan: 7, children: _jsx("div", { class: "h-4 bg-gray-200 dark:bg-gray-700 rounded" }) }) }));
/**
 * Error state component for tables with retry button
 */
export const ErrorState = ({ error, onRetry }) => (_jsxs("div", { class: "p-6 text-center", children: [_jsxs("p", { class: "text-sm text-red-600 dark:text-red-400 mb-3", children: ["Failed to load leads: ", error] }), _jsx("button", { onClick: onRetry, class: "inline-flex items-center px-3 py-1.5 text-sm font-medium rounded bg-indigo-600 text-white hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-400", children: "Retry" })] }));
/**
 * Empty state component for tables
 */
export const EmptyState = ({ message }) => (_jsx("div", { class: "p-10 text-center border border-dashed border-gray-300 dark:border-gray-600 rounded-lg", children: _jsx("p", { class: "text-sm text-gray-600 dark:text-gray-400", children: message }) }));
